import { module } from 'stereomodularjs';

function isStandalone() {
    // iOS
    if (window.navigator.standalone) return true;
    // Android/others
    if (window.matchMedia('(display-mode: standalone)').matches) return true;
    return false;
}

function isAndroid() {
    return /android/i.test(navigator.userAgent);
}

function isIOS() {
    return /iphone|ipad|ipod/i.test(navigator.userAgent);
}

function isChrome() {
    // Chrome on iOS is actually Safari under the hood, but we want to distinguish for the prompt
    return /crios/i.test(navigator.userAgent) || (/chrome/i.test(navigator.userAgent) && !/edge|edg|opr|opera|brave/i.test(navigator.userAgent));
}

function isSafari() {
    // Exclude Chrome, Edge, Opera, etc.
    return /safari/i.test(navigator.userAgent) && !/chrome|crios|android|edge|edg|opr|opera|brave/i.test(navigator.userAgent);
}

export default class extends module {
    constructor(m) {
        super(m);
        this.overlay = this.el;
        this.closeBtn = this.overlay ? this.overlay.querySelector('.js-pwa-overlay-close') : null;
        this.msgIOS = this.overlay ? this.overlay.querySelector('.js-pwa-message-ios') : null;
        this.msgChrome = this.overlay ? this.overlay.querySelector('.js-pwa-message-chrome') : null;
        this.msgAndroid = this.overlay ? this.overlay.querySelector('.js-pwa-message-android') : null;
    }

    init() {
        if (!this.overlay) return;
        // if (localStorage.getItem('pwaPromptDismissed')) return;
        if (isStandalone()) return;

        const modalItem = this.overlay.querySelector('.c-modal__item');
        if (modalItem) {
            modalItem.classList.add('is-active');
        }

        // Hide all messages first
        this.msgIOS && (this.msgIOS.style.display = 'none');
        this.msgChrome && (this.msgChrome.style.display = 'none');
        this.msgAndroid && (this.msgAndroid.style.display = 'none');

        // Show the right message
        if (isAndroid()) {
            this.msgAndroid && (this.msgAndroid.style.display = 'block');
        } else if (isIOS()) {
            if (isChrome()) {
                this.msgChrome && (this.msgChrome.style.display = 'block');
            } else if (isSafari()) {
                this.msgIOS && (this.msgIOS.style.display = 'block');
            } else {
                // Fallback to iOS message
                this.msgIOS && (this.msgIOS.style.display = 'block');
            }
        } else {
            // Fallback: show Android message (most desktop browsers can ignore)
            this.msgAndroid && (this.msgAndroid.style.display = 'block');
        }

        this.overlay.style.display = 'block';
        this.overlay.setAttribute('open', '');
        document.body.classList.add('has-pwa-overlay');

        if (this.closeBtn) {
            this.closeBtn.addEventListener('click', () => {
                this.overlay.style.display = 'none';
                this.overlay.removeAttribute('open');
                document.body.classList.remove('has-pwa-overlay');
                // localStorage.setItem('pwaPromptDismissed', '1');
            });
        }
    }
} 